import { create } from "zustand";

type State = {selectedOrganizationId: string, selectedClassId: string};

type Actions = {
  setSelectedOrganizationId: (organizationId: string) => void;
  setSelectedClassId: (classId: string) => void;
};

export const useOrganizationStore = create<State & Actions>((set) => ({
  selectedOrganizationId: '',
  selectedClassId: '',
  setSelectedClassId: (classId: string) => set(() => ({ selectedClassId: classId })),
  setSelectedOrganizationId: (organizationId: string) => set(() => ({ selectedOrganizationId: organizationId })),
}));